import { useMutation } from '@tanstack/react-query';
import { TextInlineEditor } from 'components/inline_edit/TextInlineEditor';
import { NoValue } from 'components/no_value/NoValue';
import { useNotificationContext } from 'contexts/NotificationContext';
import { usePermissions } from 'contexts/PermissionsContext';
import { LocationsTableCellProps } from 'pages/Settings/Locations/LocationsTable';
import { updateLocation } from 'utils/location';

export function LocationAbbreviationCell({ rowData, onChange }: LocationsTableCellProps) {
    const { canEditLocationDetails } = usePermissions();
    const { showToast } = useNotificationContext();
    const { mutate: updateAbbreviation, isPending } = useMutation({
        mutationFn: (abbreviation: string | undefined) =>
            updateLocation(rowData, { Abbreviation: abbreviation }),

        onSuccess: () => {
            onChange();
        },

        onError: () =>
            showToast({
                type: 'error',
                content: 'Failed to save location abbreviation',
            }),
    });

    return (
        <TextInlineEditor
            value={rowData.Abbreviation}
            renderValue={(value) => (!value ? <NoValue /> : value)}
            isDisabled={isPending || !canEditLocationDetails}
            onConfirm={updateAbbreviation}
            validate={(val) => {
                if (val && val.length > 5) {
                    return 'Abbreviation must be 5 characters or less';
                }
                return undefined;
            }}
        />
    );
}
